import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductEnhancementDocument.ListDealerDocuments.IRequest;
type Response = Api.Core.ProductEnhancementDocument.ListDealerDocuments.IResponse;
type Headers = Api.Core.ProductEnhancementDocument.ListDealerDocuments.IHeaders;
const url = '/api/ProductManagement/ProductEnhancementDocument/GetDealerDocuments';
export default async function productEnhancementDocumentListDealerDocumentsApi(
  body?: Request
): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
